import { Phone, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND } from "@/data/site";

// Sticky mobile call/quote bar — always visible on small screens.
export function MobileCallBar() {
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 border-t border-border bg-surface shadow-elev">
      <a
        href={`tel:${BRAND.phone.replace(/\s/g, "")}`}
        className="flex items-center justify-center gap-2 py-3 font-semibold text-foreground hover:bg-secondary"
      >
        <Phone className="h-4 w-4 text-accent" /> Call Now
      </a>
      <Link
        to="/contact"
        className="flex items-center justify-center gap-2 py-3 font-semibold bg-accent text-accent-foreground hover:bg-accent/90"
      >
        <MessageSquare className="h-4 w-4" /> Free Estimate
      </Link>
    </div>
  );
}
